module.exports = __webpack_public_path__ + "static/visual_4_3_eg-303cc96024ed07d522669315f7b9c09c.png";